import React from 'react';

const PerpetualMassesNotActive = () => {
  return (
    <div>
      <p>Nie przyjmujemy obecnie intencji wieczystych poprzez formularz online.</p>
    </div>
  );
};

export default PerpetualMassesNotActive;
